module.exports = __webpack_public_path__ + "img/ipay88.63041c80.png";